import Banner from "./Banner/Banner.jsx";
import styles from "./ContactUs.module.css";

const ContactUs = () => {
  const openWhatsAppChat = (phoneNumber) => {
    const message = "Hi";
    const encodedMessage = encodeURIComponent(message);

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const url = isMobile
      ? `https://wa.me/${phoneNumber}?text=${encodedMessage}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

    window.open(url, "_blank");
  };
  return (
    <main className={styles.contactPage}>
      <Banner />

      <section className={`${styles.contactBlockContainer} ${styles.contactInfo}`}>
        <div className={styles.container}>
           

          <div className={styles.contactCards}>
            {/* Phone Numbers Card */}
            <div className={styles.contactCard}>
              <div className={styles.cardHeader}>
                 
                <h4>Official Contact Channels</h4>
              </div> 
              <div className={styles.contactSection}>
                <h6>For General Information</h6>
                <a href="tel:+919340282643" className={styles.phoneNumber}>+91 93402 82643</a>
              </div>

              <div className={styles.contactSection}>
                <h6>For Memberships & Knowledge Partnership </h6>
                <a href="tel:+919399112775" className={styles.phoneNumber}>+91 93991 12775</a><br />
              </div>
            </div>

            {/* Email Addresses Card */}
            <div className={styles.contactCard}>
              <div className={styles.cardHeader}>
                 
                <h4>Official Email Addresses</h4>
              </div>
              
              <div className={styles.contactSection}>
                <h6>Administrative Office</h6>
                <a href="mailto:adminoffice@imparc.org" className={styles.emailAddress}>adminoffice@imparc.org</a>
              </div>

              <div className={styles.contactSection}>
                <h6>Membership & Author Support</h6>
                <a href="mailto:members.imparc@gmail.com" className={styles.emailAddress}>members.imparc@gmail.com</a>
              </div>

              <div className={styles.contactSection}>
                <h6>Research & Academic Engagements</h6>
                <a href="mailto:imparc.gems@gmail.com" className={styles.emailAddress}>imparc.gems@gmail.com</a>
              </div>
            </div>

            {/* WhatsApp Support Card */}
            <div className={styles.contactCard}>
              <div className={styles.cardHeader}>
                 
                <h4>WhatsApp Business (Official Support)</h4>
              </div>
              
              <div className={styles.contactSection}>
                <p>
                  For quick assistance related to membership, events, awards, or institutional collaboration, you may connect with our verified WhatsApp Business support during working hours.
                </p>
                <h6>WhatsApp Support:</h6>
                <p className={styles.phoneNumber}>
                 <button onClick={() => openWhatsAppChat("919340282643")} className={styles.phoneNumber}>+91 93402 82643</button>
                  <br /><button onClick={() => openWhatsAppChat("919399112775")} className={styles.phoneNumber}>+91 93991 12775</button>
                </p>
                <p className={styles.workingHours}>
                  (Available Monday-Saturday | 10:00 AM - 6:00 PM IST)
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office Address Section */}
      <section className={`${styles.addressSection}`}>
        <div className={styles.container}>
          <div className={styles.addressCard}>
            <div className={styles.cardHeader}>
             
              <h4>Registered Office Address</h4>
            </div>
            
            <div className={styles.addressContent}>
              <h5>Ignited Minds Edutech Pvt. Ltd.</h5>
              <p className={styles.parentOrg}>(Parent Organization of IMPARC)</p>
              <p className={styles.address}>
                212, JK Park Plaza<br />
                Alpha-II Commercial Belt<br />
                Greater Noida, Uttar Pradesh - 201310<br />
                India
              </p>
            </div>
          </div>

          <div className={styles.mapCard}>
            <div className={styles.cardHeader}>
             
              <h4>Location Map</h4>
            </div>
            
            <div className={styles.mapContainer}>
              <iframe
                title="IMPARC Office Location - Greater Noida"
                src="https://maps.google.com/maps?q=IMPARC&z=17&output=embed"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className={styles.mapFrame}
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactUs;
